import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import portadaImg from '../../assets/Totem-Get-it-portada.png';
import BrandLogo from '../common/BrandLogo';

const WelcomeScreen = ({ onStart }) => {
    const navigate = useNavigate();
    const [isVisible, setIsVisible] = useState(false);
    const [isExiting, setIsExiting] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setIsVisible(true), 100);
        return () => clearTimeout(timer);
    }, []);

    const handleStart = () => {
        setIsExiting(true);
        setTimeout(() => {
            if (onStart) {
                onStart();
            } else {
                navigate('/products');
            }
        }, 500);
    };

    return (
        <div className={`welcome-screen ${isExiting ? 'exiting' : ''}`}>
            <div className={`content ${isVisible ? 'visible' : ''}`}>
                <div className="image-wrapper">
                    <img className="portada" src={portadaImg} alt="" />
                </div>

                <div className="cta-section">
                    <button onClick={handleStart} className="order-button">
                        Pedir
                    </button>
                </div>
            </div>

            <BrandLogo delay={0.5} position="bottom-left" />

            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@900&display=swap');

                .welcome-screen {
                    position: fixed;
                    inset: 0;
                    z-index: 50;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    overflow: hidden;
                    background: linear-gradient(135deg, #0E8164 0%, #0a6b52 100%);
                    transition: opacity 0.5s ease-out, transform 0.5s ease-out;
                }

                .welcome-screen.exiting {
                    opacity: 0;
                    transform: scale(1.05);
                }

                .content {
                    position: relative;
                    z-index: 10;
                    width: 100%;
                    height: 100vh;
                    opacity: 0;
                    transform: scale(0.97);
                    transition: all 1s cubic-bezier(0.34, 1.56, 0.64, 1);
                }

                .content.visible {
                    opacity: 1;
                    transform: scale(1);
                }

                .image-wrapper {
                    width: 100%;
                    height: 100%;
                    overflow: hidden;
                }

                .portada {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    object-position: center top;
                    display: block;
                }

                .cta-section {
                    position: absolute;
                    bottom: 8rem;
                    left: 0;
                    right: 0;
                    display: flex;
                    justify-content: center;
                    padding: 0 4rem;
                }

                .order-button {
                    background: white;
                    color: #0E8164;
                    padding: 1.4rem 0;
                    font-size: 2.2rem;
                    font-weight: 900;
                    border-radius: 10rem;
                    border: none;
                    cursor: pointer;
                    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
                    transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
                    font-family: 'Montserrat', sans-serif;
                    width: 100%;
                    max-width: 32rem;
                    letter-spacing: 0.05em;
                    text-transform: uppercase;
                }

                .order-button:hover {
                    transform: translateY(-3px) scale(1.02);
                    box-shadow: 0 15px 50px rgba(0, 0, 0, 0.2);
                }

                .order-button:active {
                    transform: translateY(-1px) scale(0.99);
                }
            `}</style>
        </div>
    );
};

export default WelcomeScreen;